// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"539":"52322983","640":"52322983"}[chunkId] + ".chunk.css";
};